module.exports = __webpack_public_path__ + "img/indigent7_7-8-2021.2f3fd2fe.jpg";